import Utils from "@/core/utils/Utils";

class UzUtils {

  /**
   * Валидирует узбекский ИНН
   * @param {string} value - ИНН для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateINN(value) {
    if (typeof value !== 'string') return null;
    if (!/^\d{9}$/.test(value)) return 'ИНН должен быть 9 символов длиной';
    return null;
  }

  /**
   * Форматирует узбекский расчетный счет с разделителями
   * @param {number|string} account - Расчетный счет для форматирования (20 цифр)
   * @returns {string} Отформатированный счет (ААААА-ВВВ-К-ГГГГ-ДДДДДДД) или исходная строка если некорректный
   */
  static formatBankAccount(account) {
    const accountStr = Utils.string.toString(account);
    if (!accountStr) return '';

    // Проверяем длину узбекского расчетного счета
    if (accountStr.length !== 20) return accountStr;

    // Проверяем что состоит только из цифр
    if (!/^\d{20}$/.test(accountStr)) return accountStr;

    // Форматируем по узбекскому стандарту: ААААА-ВВВ-К-ГГГГ-ДДДДДДД
    return [
      accountStr.slice(0, 5),   // ААААА: балансовый счет (статус владельца)
      accountStr.slice(5, 8),   // ВВВ: код валюты (000=UZS, 840=USD)
      accountStr.slice(8, 9),   // К: контрольная цифра
      accountStr.slice(9, 13),  // ГГГГ: код подразделения банка
      accountStr.slice(13, 20)  // ДДДДДДД: индивидуальный номер клиента
    ].join('-');
  }

  static getBankAccountMask() {
    return '#####-###-#-####-#######';
  }

  static getBankIdMask() {
    return '###-##';
  }

  /**
   * Валидирует узбекский расчетный счет
   * @param {string} value - Расчетный счет для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateBankAccount(value) {
    // Убираем все символы кроме цифр
    const cleanValue = value.replace(/\D/g, '');

    if (cleanValue.length !== 20) {
      return 'Расчетный счет должен содержать 20 цифр';
    }

    if (!/^\d{20}$/.test(cleanValue)) {
      return 'Расчетный счет должен содержать только цифры';
    }

    return null;
  }
}

export default UzUtils;
